module.exports = __webpack_public_path__ + "img/icon_teamNum.2de1fb64.svg";